const DB_NAME = 'DAPI_DB'
const DB_VERSION = 1
const STORE_NAME = 'data'

let db = null

// 初始化数据库
const initDB = () => {
  return new Promise((resolve, reject) => {
    if (db) {
      resolve(db)
      return
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onerror = () => reject(request.error)
    request.onsuccess = () => {
      db = request.result
      resolve(db)
    }

    request.onupgradeneeded = (event) => {
      const database = event.target.result
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        database.createObjectStore(STORE_NAME)
      }
    }
  })
}

// 保存数据
const saveData = async (key, data) => {
  const database = await initDB()
  return new Promise((resolve, reject) => {
    const transaction = database.transaction([STORE_NAME], 'readwrite')
    const store = transaction.objectStore(STORE_NAME)
    // 深克隆数据，避免 Vue 响应式代理导致的克隆失败
    const clonedData = JSON.parse(JSON.stringify(data))
    const request = store.put(clonedData, key)

    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
  })
}

// 读取数据
const getData = async (key) => {
  const database = await initDB()
  return new Promise((resolve, reject) => {
    const transaction = database.transaction([STORE_NAME], 'readonly')
    const store = transaction.objectStore(STORE_NAME)
    const request = store.get(key)

    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

// 删除数据
const deleteData = async (key) => {
  const database = await initDB()
  return new Promise((resolve, reject) => {
    const transaction = database.transaction([STORE_NAME], 'readwrite')
    const store = transaction.objectStore(STORE_NAME)
    const request = store.delete(key)

    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
  })
}

// 导出所有数据
const exportAllData = async () => {
  const database = await initDB()
  return new Promise((resolve, reject) => {
    const transaction = database.transaction([STORE_NAME], 'readonly')
    const store = transaction.objectStore(STORE_NAME)
    const request = store.getAllKeys()

    request.onsuccess = async () => {
      const keys = request.result
      const data = {}
      for (const key of keys) {
        data[key] = await getData(key)
      }
      resolve(data)
    }
    request.onerror = () => reject(request.error)
  })
}

// 导入数据
const importAllData = async (data) => {
  for (const [key, value] of Object.entries(data)) {
    await saveData(key, value)
  }
}

export const indexedDBStorage = {
  saveData,
  getData,
  deleteData,
  exportAllData,
  importAllData
}
